/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { useAlert } from "react-alert";

import context from "../../../../../../../context/auth-context";
import errorHandler from "../../../../../../../hoc/ErrorHandler";
import SlidingPane from "../../../../../../UI/SlidingPane/SlidingPane";
import Spinner from "../../../../../../UI/Spinner/Spinner";
import { DISMISS_MEGA_MENU } from "../../../../../../../constants";
import Form from "./Form/Form";
import Overflow from "../../../../../../UI/Overflow/Overflow";
import defaultLogo from "../../../../../../../assets/images/default-company-logo.png";
import Error from "./Error/Error";
import { alpha, Box } from "@mui/system";
import { ButtonBase, Stack } from "@mui/material";
import { theme } from "components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper";

const Companies = (props) => {
  const [slidingPaneOpen, setSlidingPaneOpen] = useState(false);
  const [companyToEdit, setCompanyToEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [companyColors, setCompanyColors] = useState({
    primary: "#000000",
    secondary: "#000000",
    tertiary: "#000000",
    auxilliary: "#000000",
  });
  const [companyLogo, setCompanyLogo] = useState(defaultLogo);
  const [companyPhone, setCompanyPhone] = useState(null);

  const companies = useCallback(
    () => props.companies.data,
    [props.companies.data]
  );
  const error = useCallback(
    () => props.companies.error,
    [props.companies.error]
  );

  const authContext = useContext(context);
  const alert = useAlert();
  const companyNameShortener = (name) =>
    name.length > 20 ? name.substring(0, 20).concat("...") : name;

  const editCompanyButtonClickHandler = (company) => {
    const colors = { ...companyColors };

    colors.primary = company.primary_color;
    colors.secondary = company.secondary_color;
    colors.tertiary = company.tertiary_color;
    colors.auxilliary = company.auxilliary_color;

    setCompanyColors(colors);
    DISMISS_MEGA_MENU();
    setCompanyPhone(company.phone);
    setCompanyToEdit(company);

    return setSlidingPaneOpen(true);
  };

  useEffect(() => {
    const getCompanies = async () => {
      return await axios.get(`/users/${authContext.userId}/account/companies`, {
        headers: {
          "Company-Code": authContext.companyCode,
        },
      });
      // if (companies) {
      //     props.onInstantiateCompanies(companies.data);
      //     // props.onInstantiateCompanyLogo(companyLogo)
      //     setLoading(false);
      // } else {
      //     props.onInstantiateCompaniesError();
      //     setLoading(false);
      // }
    };

    getCompanies()
      .then((res) => {
        if (res) {
          props.onInstantiateCompanies(res.data);
          // props.onInstantiateCompanyLogo(companyLogo)
          setLoading(false);
        }
      })
      .catch((err) => {
        props.onInstantiateCompaniesError();
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.accessToken, authContext.refreshToken]);

  const changeCompanyHandler = (id, name) => {
    if (id === authContext.companyId) return;

    props.onSwitchCompany(id, name);
    props.onResetApprovals();
    props.onResetResources();
    props.onResetEvents();
    props.onResetGroups();
    props.onResetUsers();
    props.onResetNonUsers();

    return props.match.url !== "/" ? DISMISS_MEGA_MENU() : null;
  };

  const slidingPaneCloseHandler = () => {
    const colors = { ...companyColors };

    colors.primary = "#000000";
    colors.secondary = "#000000";
    colors.tertiary = "#000000";
    colors.auxilliary = "#000000";

    if (companyToEdit) setCompanyToEdit(null);
    if (companyPhone) setCompanyPhone(null);
    setCompanyColors(colors);
    setCompanyLogo(defaultLogo);

    return setSlidingPaneOpen(false);
  };

  const newCompanyButtonClickHandler = () => {
    DISMISS_MEGA_MENU();
    return setSlidingPaneOpen(true);
  };

  const primaryColorChangeHandler = (color) => {
    const colors = { ...companyColors };
    colors.primary = color;
    return setCompanyColors(colors);
  };

  const secondaryColorChangeHandler = (color) => {
    const colors = { ...companyColors };
    colors.secondary = color;
    return setCompanyColors(colors);
  };

  const tertiaryColorChangeHandler = (color) => {
    const colors = { ...companyColors };
    colors.tertiary = color;
    return setCompanyColors(colors);
  };

  const auxilliaryColorChangeHandler = (color) => {
    const colors = { ...companyColors };
    colors.auxilliary = color;
    return setCompanyColors(colors);
  };

  const companyPhoneChangeHandler = (phone) => {
    const value = phone && phone.replace(/ /g, "");
    return setCompanyPhone(value);
  };

  const companyCreateHandler = async (company) => {
    const companyDetails = {
      ...company,
      admin: authContext.userId,
      colors: { ...companyColors },
    };

    if (companyLogo !== defaultLogo)
      companyDetails.logo = companyLogo.split(",")[1];

    const response = await axios.post("/utilities/companies", companyDetails, {
      headers: {
        Authorization: authContext.accessToken,
        "Company-Code": authContext.companyCode,
        "Company-Id": authContext.companyId,
      },
    });

    if (response) {
      slidingPaneCloseHandler();
      alert.show(response.data.message, { type: "success" });
      return props.onCreateCompany(response.data.data);
    }
  };

  const companyUpdateHandler = async (company) => {
    const companyDetails = {
      ...company,
      id: parseInt(companyToEdit.id),
      colors: { ...companyColors },
    };

    if (companyLogo !== defaultLogo)
      companyDetails.logo = companyLogo.split(",")[1];

    companyDetails.phone =
      companyPhone && companyPhone.length >= 7 && companyPhone.length < 15
        ? companyPhone
        : null;

    const response = await axios.patch(
      `/utilities/companies/${companyDetails.id}`,
      companyDetails,
      {
        headers: {
          Authorization: authContext.accessToken,
          "Company-Code": authContext.companyCode,
        },
      }
    );

    if (response) {
      slidingPaneCloseHandler();
      alert.show(response.data.message, { type: "success" });
      return props.onUpdateCompany(response.data.data);
    }
  };

  return (
    <Fragment>
      <div className="col-md-3">
        <h5>Your companies</h5>
        {!loading ? (
          !error() ? (
            <ul className="blocks-1">
              <Overflow maxHeight="450px">
                <li className="mega-menu m-0">
                  {companies()?.map((company) => {
                    return (
                      <ButtonBase
                        component={Stack}
                        key={company.id}
                        sx={{
                          bgcolor:
                            authContext.companyId === company.id
                              ? "rgb(0,0,0,.1)"
                              : "background.paper",
                          borderRadius: "5px",
                          minWidth: "100%",
                          justifyContent: "space-between",
                          px: 2,
                          mb: 1,
                          "& :hover": {
                            bgcolor:
                              authContext.companyId === company.id
                                ? "rgb(0,0,0,0)"
                                : alpha(theme.palette.primary.light, 0.1),
                            backgroundBlendMode: "differencep",
                            transform: "scale(1.05)",
                          },
                        }}
                        spacing={1}
                        direction="row"
                      >
                        <button
                          type="button"
                          className="btn btn-link"
                          onClick={changeCompanyHandler.bind(
                            this,
                            company.id,
                            company.name
                          )}
                          style={{
                            fontWeight:
                              authContext.companyId === company.id
                                ? 800
                                : "normal",
                            color:
                              company.is_default === "Y"
                                ? "#4caf50"
                                : "default",
                          }}
                          data-tip={company.name}
                          data-place="right"
                          data-effect="solid"
                        >
                          <i
                            className="md-chevron-right"
                            aria-hidden="true"
                          ></i>
                          &nbsp;{companyNameShortener(company.name)}
                        </button>
                        <ReactTooltip />
                        <button
                          type="button"
                          className="btn btn-link"
                          style={{ float: "right" }}
                          onClick={editCompanyButtonClickHandler.bind(
                            this,
                            company
                          )}
                          disabled={
                            slidingPaneOpen || authContext.isICT === "Y"
                          }
                        >
                          <i className="ti ti-pencil" aria-hidden="true"></i>
                          &nbsp;Edit
                        </button>
                      </ButtonBase>
                    );
                  })}
                </li>
              </Overflow>
            </ul>
          ) : (
            <Error />
          )
        ) : (
          <Spinner />
        )}

        <button
          type="submit"
          className="btn btn-block btn-raised btn-animate btn-animate-vertical btn-default btn-sm waves-effect waves-classic"
          style={{ marginTop: "10px" }}
          disabled={authContext.isICT === "Y" || props.companies.error}
          onClick={newCompanyButtonClickHandler}
        >
          <span>
            <i className="icon ti-plus" aria-hidden="true"></i>&nbsp;New Company
          </span>
        </button>
      </div>
      <SlidingPane
        open={slidingPaneOpen}
        title={!companyToEdit ? "New company" : companyToEdit.name}
        subtitle={!companyToEdit ? "Create a company" : "Edit company details"}
        onRequestClose={slidingPaneCloseHandler}
      >
        <Form
          submitHandler={
            !companyToEdit ? companyCreateHandler : companyUpdateHandler
          }
          companyLogo={companyLogo}
          companyPhone={companyPhone}
          logoHandler={(logo) => setCompanyLogo(logo)}
          colors={companyColors}
          companyToEdit={companyToEdit}
          primaryColorChangeHandler={(color) =>
            primaryColorChangeHandler(color)
          }
          secondaryColorChangeHandler={(color) =>
            secondaryColorChangeHandler(color)
          }
          tertiaryColorChangeHandler={(color) =>
            tertiaryColorChangeHandler(color)
          }
          auxilliaryColorChangeHandler={(color) =>
            auxilliaryColorChangeHandler(color)
          }
          companyPhoneChangeHandler={(phone) =>
            companyPhoneChangeHandler(phone)
          }
        />
      </SlidingPane>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: state.utilities.companies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInstantiateCompanies: (companies) =>
      dispatch({ type: "INSTANTIATE_COMPANIES", payload: companies }),
    onInstantiateCompaniesError: () =>
      dispatch({ type: "INSTANTIATE_COMPANIES_ERROR" }),
    onInstantiateCompanyLogo: (companyLogo) =>
      dispatch({ type: "INSTANTIATE_COMPANY_LOGO", payload: companyLogo }),
    onSwitchCompany: (id, name) =>
      dispatch({
        type: "SWITCH_COMPANY",
        payload: {
          id: id,
          name: name,
        },
      }),
    onCreateCompany: (company) =>
      dispatch({ type: "CREATE_COMPANY", payload: company }),
    onUpdateCompany: (company) =>
      dispatch({ type: "UPDATE_COMPANY", payload: company }),
    onResetApprovals: () => dispatch({ type: "RESET_APPROVALS" }),
    onResetResources: () => dispatch({ type: "RESET_RESOURCES" }),
    onResetEvents: () => dispatch({ type: "RESET_EVENTS" }),
    onResetGroups: () => dispatch({ type: "RESET_GROUPS" }),
    onResetUsers: () => dispatch({ type: "RESET_USERS" }),
    onResetNonUsers: () => dispatch({ type: "RESET_NONUSERS" }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(errorHandler(Companies, axios)));
